import crypto from "crypto";
import OSS from "ali-oss";

const instances = {};

export function getFileTarget(file, md5) {
    let ext = /\.\w+/.exec(file.name)
    if (/^video\//.test(file.type)) {
        ext = '.mp4'
    }
    if (/^audio\//.test(file.type)) {
        ext = '.mp3'
    }
    return md5[0] + '/' + md5[1] + '/' + md5 + ext
}

export function md5File(file) {
    return new Promise((resolve, reject) => {
        try {
            const f = new FileReader()
            f.readAsArrayBuffer(file)
            f.onload = () => {
                const buffer = Buffer.from(f.result)
                const md5 = crypto.createHash('md5').update(buffer).digest('hex')
                resolve(md5)
            }
        } catch (error) {
            reject(error)
        }
    });
}

class FileClient {

    _oss;

    constructor(opts) {
        this._oss = new OSS(opts);
    }

    async head(path) {
        try {
            return await this._oss.head(path)
        } catch (error) {
            if (error.status === 404) {
                return Promise.resolve(null)
            }
            throw error
        }
    }

    async filename(path) {
        const data = await this.head(path);
        if ('x-oss-meta-filename' in data.res.headers) {
            return decodeURI(data.res.headers['x-oss-meta-filename'])
        } else if ('content-disposition' in data.res.headers) {
            let m = /filename=(.+?)(;|$)/.exec(data.res.headers['content-disposition'])
            if (m && m.length > 1) {
                return decodeURI(m[1])
            }
        }
    }

    async upload(file, opts) {
        const {base, dest, progress} = opts;
        let md5 = await md5File(file)
        let target = getFileTarget(file, md5)
        let path = dest + '/' + target
        let head = await this.head(path)
        if (!head) {
            let name = encodeURI(file.name)
            head = await this._oss.multipartUpload(path, file, {
                mime: file.type,
                headers: {
                    'Content-Disposition': `filename=${name};filename*=UTF8"${name}`
                },
                meta: {
                    filename: name
                },
                progress
            })
        } else if (progress) {
            progress(1)
        }
        return {
            target,
            source: path,
            url: base + '/' + target,
            file: head.res
        }
    }

    async download(path, filename) {
        const res = await this._oss.get(path);
        let bold = new Blob([res.content], {type: res.res.headers['content-type']});
        let url = URL.createObjectURL(bold);
        let file = document.createElement('a');
        file.href = url;
        file.download = filename;
        file.dispatchEvent(new MouseEvent('click'));
        URL.revokeObjectURL(url);
    }
}

/**
 * 打开文件客户端
 * @param bucket {string}
 * @returns {FileClient}
 */
export function openFileClient(bucket) {
    if (instances[bucket]) {
        instances[bucket].count++;
        return instances[bucket].client;
    } else {
        const config = {
            hskonline: {
                region: 'oss-cn-hongkong',
                accessKeyId: 'LTAIKTpzacbFPRdj',
                accessKeySecret: 'C2Z6HuzCUJZHdtSTtcKsRwcQWGgo09',
                bucket: 'hskonline'
            },
            superchinese: {
                region: 'oss-cn-hongkong',
                accessKeyId: 'LTAIKTpzacbFPRdj',
                accessKeySecret: 'C2Z6HuzCUJZHdtSTtcKsRwcQWGgo09',
                bucket: 'superchinese'
            }
        };
        const client = new FileClient(config[bucket]);
        instances[bucket] = {client, count: 1};
        return client;
    }
}

/**
 * 关闭文件客户端
 * @param bucket {string}
 */
export function closeFileClient(bucket) {
    if (instances[bucket] && --instances[bucket].count < 1) {
        delete instances[bucket];
    }
}

/**
 * 获取文件客户端
 * @param bucket {string}
 * @returns {FileClient}
 */
export function getFileClient(bucket) {
    if (instances[bucket]) {
        return instances[bucket].client;
    }
    return openFileClient(bucket);
}